<template>
  <div ref="mask" class="dialog-mask" :class="[show ? 'show' : '', type + '-mask' ]">
    <div ref="dialog" class="dialog">
      <i class="dialog-close" @click="close"></i>
      <div class="dialog-body" :class="type + '-dialog'">
        <h3 class="title" v-if="title">{{title}}</h3>
        <slot name="dialog-content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  props: {
    type: String,
    title: String,
    show: Boolean
  },
  data () {
    return {
      leave: false,
      animate: Function
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.showDialog()
      } else {
        this.$refs.mask.style.opacity = 0
      }
    }
  },
  methods: {
    showDialog () {
      switch (this.type) {
        case 'buy':
        case 'refresh':
          anime.maskIn(this.$refs.mask, () => {
            anime.heartBeatIn(this.$refs.dialog)
          })
        break
        default:
          anime.maskIn(this.$refs.mask, () => {
            anime.topIn(this.$refs.dialog)
          })
        break
      }
    },
    close () {
      switch (this.type) {
        case 'buy':
        case 'refresh':
          anime.heartBeatOut(this.$refs.dialog, () => {
            anime.maskOut(this.$refs.mask, () => {
              this.hideDialog()
            }, 200, 200)
          })
          break
        default:
          anime.topOut(this.$refs.dialog, () => {
            anime.maskOut(this.$refs.mask, () => {
              this.hideDialog()
            })
          })
        break
      }
    },
    hideDialog () {
      switch (this.type) {
        case 'rule':
          this.$bus.rule.show = false
        break
        case 'history':
          this.$bus.history.show = false
        break
        case 'buy':
          this.$bus.buy.show = false
        break
        case 'refresh':
          this.$bus.refreshDialog.show = false
        break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100vw;
  height: 100vh;
  opacity: 0;
  background: rgba(0, 0, 0, .82);
  display: none;
}
.dialog-mask.show {
  display: block;
}
.dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  @include px2res(width, 752);
  @include px2res(height, 458);
  @include px2res(margin, -229, 0, 0, -376);
  .dialog-close {
    position: absolute;
    z-index: 9;
    @include px2res(top, 12);
    @include px2res(left, -96);
    @include px2res(width, 69);
    @include px2res(height, 69);
  }
  .dialog-body {
    @include flexrc;
    flex-direction: column;
    margin: 0 auto;
    overflow: hidden;
    .title {
      width: 100%;
      text-align: center;
      color: #FFDF00;
      position: relative;
      z-index: 1;
      @include px2res(font-size, 54);
      text-transform: uppercase;
    }
  }
  // rule-dialog
  // .rule-dialog {
  //   width: 92%;
  //   height: 96%;
  //   align-items: flex-start;
  //   justify-content: flex-start;
  //   @include px2res(padding, 54, 60, 20, 100);
  // }
  // history dialog
  // .history-dialog {
  //   width: 100%;
  //   max-height: 100%;
  //   @include px2res(padding, 54, 74, 0);
  // }
  // reward dialog
  .buy-dialog, .rule-dialog {
    width: 100%;
    height: 100%;
    @include px2res(padding, 20);
  }
  .history-dialog {
    width: 100%;
    height: 100%;
    @include px2res(padding, 20, 10);
  }
  .rule-dialog, .history-dialog {
    align-items: flex-start;
    justify-content: flex-start;
  }
  .refresh-dialog {
    width: 100%;
    height: 100%;
    @include px2res(padding, 60, 20, 20);
    justify-content: space-around;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Dialog.vue